import { useEffect, useState } from "react";
import { getDateUtil, yesterday, today } from "../../util/formatDate";
import { postAxios } from "../../util/apiCall";
import { v4 as uuidv4 } from "uuid";

export const useOperator = () => {
  const dataAuth = localStorage.getItem("auth");
  const dataUser = JSON.parse(dataAuth);

  const [dataReject, setDataReject] = useState([
    { id: "Pilih Alasan", totalNG: "" },
  ]);
  const [dataRejectSticker, setDataRejectSticker] = useState([
    { id: "Pilih Alasan", totalNG: "", shift: "" },
  ]);
  const [dataKeterangan, setDataKeterangan] = useState([
    { jam: "", keterangan: "" },
  ]);
  const [dateOperator, setDateOperator] = useState(today);
  const [shiftOperator, setShiftOperator] = useState("Pilih Shift");
  const [mesinOperator, setMesinOperator] = useState("Pilih Mesin");
  const [rejectDesc, setRejectDesc] = useState();
  const [isiPerKemasan, setIsiPerKemasan] = useState();
  const [aktualCavity, setAktualCavity] = useState();
  const [counterAkhir, setCounterAkhir] = useState();
  const [counterAwal, setCounterAwal] = useState();
  const [jumlahBarang, setJumlahBarang] = useState();
  let jumlahNG = (counterAkhir - counterAwal) * aktualCavity - jumlahBarang;
  const [downtime, setDowntime] = useState();
  const [keterangan, setKeterangan] = useState("");
  const [isError, setIsError] = useState(false);
  const [popUpKirim, setPopUpKirim] = useState(false);
  const [subMenuOperator, setSubMenuOperator] = useState("laporanProduksi");
  const [isToco, setIsToco] = useState(false);
  const [sisaShiftSebelumnya, setSisaShiftSebelumnya] = useState();
  const [produkVP, setProdukVP] = useState("Pilih Produk");
  const [shiftPasangKaret, setShiftPasangKaret] = useState("Pilih Shift");

  const [mesinPasangKaret, setMesinPasangKaret] = useState("Pilih Mesin");
  const [keteranganPasangKaret, setKeteranganPasangKaret] = useState("");
  const [jumlahPasangKaret, setJumlahPasangKaret] = useState("");
  const [isErrorPasangKaret, setIsErrorPasangKaret] = useState(false);
  const [downtimePasangKaret, setDowntimePasangKaret] = useState("");
  const [kepalaShift, setKepalaShift] = useState("Pilih Kepala Shift");
  const [warnaVP, setWarnaVP] = useState("Pilih Warna");
  const [aktualCavityPasangKaret, setAktualCavityPasangKaret] = useState("");
  const [customerVentPlug, setCustomerVentPlug] = useState("Pilih Customer");
  const [keteranganSementara, setKeteranganSementara] = useState("");
  const [aktualBarang, setAktualBarang] = useState();
  const [ngSticker, setNgSticker] = useState();
  const [rejectProduk, setRejectProduk] = useState();

  const [dataListMold, setDataListMold] = useState();
  const [dataListPR, setDataListPR] = useState();

  const [pasangStikerSelect, setPasangStikerSelect] = useState();
  const [errorPasangSticker, setErrorPasangSticker] = useState(false);

  const v4Id = uuidv4();

  useEffect(() => {
    postAxios(
      `${process.env.REACT_APP_ENDPOINT}/getListPerincian`,
      {},
      dataUser.auth,
      setRejectDesc,
      ""
    );
    postAxios(
      `${process.env.REACT_APP_ENDPOINT}/createNotes`,
      {
        tim: dataUser.tim,
        id: dataUser.id,
        keteranganSementara: keteranganSementara,
      },
      dataUser.auth,
      setKeteranganSementara,
      ""
    );
    if (dataUser.tim === 2) {
      postAxios(
        `${process.env.REACT_APP_ENDPOINT}/getListMold`,
        { tim: dataUser.tim },
        dataUser.auth,
        setDataListMold,
        ""
      );
    } else if (dataUser.tim === 1) {
      postAxios(
        `${process.env.REACT_APP_ENDPOINT}/secondProcess`,
        { tim: dataUser.tim, bagian: "PR", type: "getProduk" },
        dataUser.auth,
        setDataListPR,
        ""
      );
    }
  }, []);

  const handleRejectDesc = (index, event, type) => {
    let data = [...dataReject];
    if (type === "kindOfReject") {
      let find = data.find((i) => i.id === event.label);
      if (!find) {
        data[index].id = event.label;
      }
    } else {
      data[index][event.target.name] = Number(event.target.value);
    }

    setDataReject(data);
  };

  const handleRejectSticker = (index, event, type) => {
    let data = [...dataRejectSticker];
    if (type === "kindOfReject") {
      let find = data.find(
        (i, idx) =>
          i.id === event.label && i.shift === data[index].shift && idx !== index
      );
      if (!find) {
        data[index].id = event.label;
      }
    } else if (type === "shift") {
      data[index][event.target.name] = event.target.value;
    } else {
      data[index][event.target.name] = Number(event.target.value);
    }

    setDataRejectSticker(data);
  };

  const addFieldsKeterangan = () => {
    let newfield = { jam: "", keterangan: "" };
    setDataKeterangan([...dataKeterangan, newfield]);
  };

  const removeFieldsKeterangan = () => {
    let data = [...dataKeterangan];
    if (data.length > 1) {
      data.splice(data.length - 1);
      setDataKeterangan(data);
    }
  };

  // Operator cukup ketik angka: 08000900 -> 08:00-09:00
  const formatJam = (raw) => {
    const d = (raw || "").replace(/\D/g, "").slice(0, 8);
    const pairs = d.match(/.{1,2}/g) || [];
    const clamp = (p = "", max) =>
      p.length === 2 && Number(p) > max ? String(max) : p;

    const h1 = clamp(pairs[0], 23);
    const m1 = clamp(pairs[1], 59);
    const h2 = clamp(pairs[2], 23);
    const m2 = clamp(pairs[3], 59);

    let result = h1;
    if (m1) result += ":" + m1;
    if (h2) result += "-" + h2;
    if (m2) result += ":" + m2;
    return result;
  };

  const handleKeterangan = (index, event) => {
    let data = [...dataKeterangan];
    const { name, value } = event.target;
    data[index][name] = name === "jam" ? formatJam(value) : value;

    setDataKeterangan(data);
  };

  const addFields = () => {
    let newfield = {
      id: "Pilih Alasan",
      totalNG: "",
    };
    setDataReject([...dataReject, newfield]);
  };

  const removeFields = () => {
    let data = [...dataReject];
    if (data.length > 1) {
      data.splice(data.length - 1);
      setDataReject(data);
    }
  };

  const addFieldsSticker = () => {
    let newfield = {
      id: "Pilih Alasan",
      totalNG: "",
      shift: "",
    };
    setDataRejectSticker([...dataRejectSticker, newfield]);
  };

  const removeFieldsSticker = () => {
    let data = [...dataRejectSticker];
    if (data.length > 1) {
      data.splice(data.length - 1);
      setDataRejectSticker(data);
    }
  };

  const handleKirim = () => {
    let jumlahReject = 0;

    dataReject &&
      dataReject.forEach((element) => {
        jumlahReject += Number(element.totalNG);
      });
    const reStructure = {
      id: v4Id,
      userId: dataUser.id,
      tim: dataUser.tim,
      shift: shiftOperator,
      mesin: mesinOperator,
      date: getDateUtil(dateOperator),
      yesterday: getDateUtil(yesterday),
      isiPerKemasan: Number(isiPerKemasan),
      aktualCavity: Number(aktualCavity),
      perincianNG: dataReject,
      counterAkhir: Number(counterAkhir),
      counterAwal: Number(counterAwal),
      jumlahNG: jumlahNG ? Number(jumlahNG) : 0,
      sisaShiftSebelumnya: Number(sisaShiftSebelumnya),
      jumlahBarang: Number(jumlahBarang),
      downtime: Number(downtime),
      keterangan: keterangan,
      dataKeterangan: dataKeterangan,
      operator: dataUser.name,
      isKepala: false,
      isAdmin: false,
      isWarehouse: false,
      isToco: isToco,
      aktualBarang: Number(aktualBarang),
    };
    const isValid =
      dataReject &&
      dataReject.every(
        (item) =>
          typeof item.id === "string" &&
          item.id.trim() !== "" &&
          item.id !== "Pilih Alasan"
      );

    const checkingIsValid = jumlahNG > 0 ? isValid : true;

    if (
      shiftOperator !== "Pilih Shift" &&
      mesinOperator !== "Pilih Mesin" &&
      isiPerKemasan !== "" &&
      aktualCavity !== "" &&
      counterAkhir !== "" &&
      counterAwal !== "" &&
      jumlahBarang !== "" &&
      jumlahReject === Number(jumlahNG) &&
      checkingIsValid
    ) {
      postAxios(
        `${process.env.REACT_APP_ENDPOINT}/laporanOperator`,
        { data: reStructure },
        dataUser.auth,
        "",
        ""
      );
      setIsError(false);
      setPopUpKirim(true);
      window.scrollTo({ top: 0, behavior: "smooth" });
      setShiftOperator("Pilih Shift");
      setMesinOperator("Pilih Mesin");
      setWarnaVP("Pilih Warna");
      setDataReject([{ id: "Pilih Alasan", totalNG: "" }]);
      setIsToco(false);

      setSisaShiftSebelumnya(0);
      setAktualBarang(0);
      setIsiPerKemasan(0);
      setAktualCavity(0);
      setCounterAkhir(0);
      setCounterAwal(0);
      setJumlahBarang(0);
      setDowntime(0);
      setKeterangan("");
      setDataKeterangan([{ jam: "", keterangan: "" }]);
    } else {
      setIsError(true);
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const handleKirimPasangKaret = () => {
    if (
      produkVP !== "Pilih Produk" &&
      shiftPasangKaret !== "Pilih Shift" &&
      mesinPasangKaret !== "Pilih Mesin" &&
      jumlahPasangKaret !== "" &&
      kepalaShift !== "Pilih Kepala Shift" &&
      warnaVP !== "Pilih Warna" &&
      customerVentPlug !== "Pilih Customer"
    ) {
      postAxios(
        `${process.env.REACT_APP_ENDPOINT}/submitPasangKaret`,
        {
          data: {
            id: v4Id,
            tim: dataUser.tim,
            date: getDateUtil(dateOperator),
            produk: produkVP,
            warna: warnaVP,
            shift: shiftPasangKaret,
            mesin: mesinPasangKaret,
            jumlah: Number(jumlahPasangKaret),
            operator: dataUser.name,
            keterangan: keteranganPasangKaret,
            downtime: Number(downtimePasangKaret),
            aktualCavity: Number(aktualCavityPasangKaret),
            customer: customerVentPlug,
            isKepala: false,
            isAdmin: false,
            kepalaShift: kepalaShift,
          },
        },
        dataUser.auth,
        "",
        ""
      );

      setProdukVP("Pilih Produk");
      setShiftPasangKaret("Pilih Shift");
      setMesinPasangKaret("Pilih Mesin");
      setWarnaVP("Pilih Warna");
      setDowntimePasangKaret("");
      setKeteranganPasangKaret("");
      setJumlahPasangKaret("");
      setAktualCavityPasangKaret("");
      setKepalaShift("Pilih Kepala Shift");
      setCustomerVentPlug("Pilih Customer");
      setIsErrorPasangKaret(false);
      setPopUpKirim(true);
    } else {
      setIsErrorPasangKaret(true);
    }
  };

  let listReject = [];

  rejectDesc &&
    rejectDesc.forEach((element) => {
      listReject.push({ value: element.id, label: element.desc });
    });

  let listProduk = [];

  if (dataUser.tim === 2) {
    dataListMold &&
      dataListMold.forEach((element) => {
        if (element.company === customerVentPlug) {
          element.data.forEach((obj) => {
            listProduk.push({ value: obj.id, label: obj.name });
          });
        }
      });
  } else {
    dataListPR &&
      dataListPR.forEach((element) => {
        if (element.customer === customerVentPlug) {
          element.data.forEach((obj) => {
            listProduk.push({ value: obj.id, label: obj.produk });
          });
        }
      });
  }

  const handleKirimPasangStiker = () => {
    const sumReject =
      dataRejectSticker &&
      dataRejectSticker.reduce(function (s, a) {
        return s + Number(a.totalNG);
      }, 0);

    const findPilihShift =
      dataRejectSticker &&
      dataRejectSticker.some(function (a) {
        if (sumReject > 0) {
          return a.shift !== "" && a.id !== "Pilih Alasan";
        } else {
          return true;
        }
      });

    if (
      (dataUser.tim === 2 &&
        shiftOperator !== "Pilih Shift" &&
        mesinOperator !== "Pilih Mesin" &&
        kepalaShift !== "Pilih Kepala Shift" &&
        pasangStikerSelect &&
        jumlahPasangKaret !== "") ||
      (dataUser.tim === 1 &&
        shiftOperator !== "Pilih Shift" &&
        mesinOperator !== "Pilih Mesin" &&
        kepalaShift !== "Pilih Kepala Shift" &&
        pasangStikerSelect &&
        jumlahPasangKaret !== "" &&
        Number(rejectProduk) === sumReject &&
        findPilihShift)
    ) {
      let check = [];
      if (dataUser.tim === 2) {
        dataListMold &&
          dataListMold.forEach((element) => {
            if (element.company === customerVentPlug) {
              element.data.forEach((obj) => {
                if (obj.id === pasangStikerSelect.value) check.push(obj);
              });
            }
          });
      } else {
        dataListPR &&
          dataListPR.forEach((element) => {
            if (element.customer === customerVentPlug) {
              element.data.forEach((obj) => {
                if (obj.id === pasangStikerSelect.value) check.push(obj);
              });
            }
          });
      }

      let produkName = dataUser.tim === 2 ? check[0].name : check[0].produk;

      postAxios(
        `${process.env.REACT_APP_ENDPOINT}/pasangAksesoris`,
        {
          type: "stiker",
          data: {
            id: v4Id,
            tim: dataUser.tim,
            date: getDateUtil(dateOperator),
            produk: produkName,
            color: check[0].color,
            shift: shiftOperator,
            mesin: mesinOperator,
            jumlah: Number(jumlahPasangKaret),
            reject: Number(ngSticker),
            rejectProduk: Number(rejectProduk),
            operator: dataUser.name,
            keterangan: keteranganPasangKaret,
            downtime: Number(downtimePasangKaret),
            customer: customerVentPlug,
            isKepala: false,
            isAdmin: false,
            kepalaShift: kepalaShift,
            kindOfReject: dataRejectSticker,
          },
        },
        dataUser.auth,
        "",
        ""
      );
      setPopUpKirim(true);
      setShiftOperator("Pilih Shift");
      setMesinOperator("Pilih Mesin");
      setDateOperator(today);
      setNgSticker();
      setRejectProduk();
      setRejectProduk();
      setDataRejectSticker([{ id: "Pilih Alasan", totalNG: "", shift: "" }]);
      setErrorPasangSticker(false);
      setKepalaShift("Pilih Kepala Shift");
      setCustomerVentPlug("Pilih Customer");
      setPasangStikerSelect();
      setJumlahPasangKaret("");
      setDowntimePasangKaret("");
      setKeteranganPasangKaret("");
    } else {
      setErrorPasangSticker(true);
    }
  };

  const handleKirimPasangTopPlate = () => {
    if (
      shiftOperator !== "Pilih Shift" &&
      mesinOperator !== "Pilih Mesin" &&
      kepalaShift !== "Pilih Kepala Shift" &&
      pasangStikerSelect &&
      jumlahPasangKaret !== ""
    ) {
      postAxios(
        `${process.env.REACT_APP_ENDPOINT}/pasangAksesoris`,
        {
          type: "topPlate",
          data: {
            id: v4Id,
            tim: dataUser.tim,
            date: getDateUtil(dateOperator),
            produk: pasangStikerSelect.value,
            shift: shiftOperator,
            mesin: mesinOperator,
            jumlah: Number(jumlahPasangKaret),
            operator: dataUser.name,
            keterangan: keteranganPasangKaret,
            downtime: Number(downtimePasangKaret),
            customer: "GS",
            isKepala: false,
            isAdmin: false,
            kepalaShift: kepalaShift,
          },
        },
        dataUser.auth,
        "",
        ""
      );
      setPopUpKirim(true);
      setShiftOperator("Pilih Shift");
      setMesinOperator("Pilih Mesin");
      setDateOperator(today);
      setKepalaShift("Pilih Kepala Shift");
      setCustomerVentPlug("Pilih Customer");
      setPasangStikerSelect();
      setJumlahPasangKaret("");
      setDowntimePasangKaret("");
      setKeteranganPasangKaret("");
    } else {
      setErrorPasangSticker(true);
    }
  };

  return {
    dataUser,
    dataReject,
    handleRejectDesc,
    addFields,
    removeFields,
    shiftOperator,
    setShiftOperator,
    setIsiPerKemasan,
    setAktualCavity,
    setCounterAkhir,
    setCounterAwal,
    setJumlahBarang,
    setKeterangan,
    setMesinOperator,
    setDateOperator,
    handleKirim,
    mesinOperator,
    isiPerKemasan,
    aktualCavity,
    counterAkhir,
    counterAwal,
    jumlahNG,
    jumlahBarang,
    keterangan,
    isError,
    popUpKirim,
    setDowntime,
    downtime,
    setPopUpKirim,
    subMenuOperator,
    setSubMenuOperator,

    dateOperator,
    isToco,
    setIsToco,
    sisaShiftSebelumnya,
    setSisaShiftSebelumnya,
    produkVP,
    setProdukVP,
    shiftPasangKaret,
    setShiftPasangKaret,
    mesinPasangKaret,
    setMesinPasangKaret,
    keteranganPasangKaret,
    setKeteranganPasangKaret,
    handleKirimPasangKaret,
    jumlahPasangKaret,
    setJumlahPasangKaret,
    isErrorPasangKaret,
    setIsErrorPasangKaret,
    setDowntimePasangKaret,
    downtimePasangKaret,
    kepalaShift,
    setKepalaShift,
    warnaVP,
    setWarnaVP,
    aktualCavityPasangKaret,
    setAktualCavityPasangKaret,
    setCustomerVentPlug,
    customerVentPlug,

    listReject,
    aktualBarang,
    setAktualBarang,
    dataListMold,
    listProduk,
    pasangStikerSelect,
    setPasangStikerSelect,
    handleKirimPasangStiker,
    dataListPR,
    errorPasangSticker,
    handleKirimPasangTopPlate,
    dataKeterangan,
    handleKeterangan,
    ngSticker,
    setNgSticker,
    addFieldsKeterangan,
    removeFieldsKeterangan,
    rejectProduk,
    setRejectProduk,
    addFieldsSticker,
    removeFieldsSticker,
    dataRejectSticker,
    handleRejectSticker,
  };
};
